/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import IconImage from '../../components/IconImage';

const Edit = ( props ) => {
	const { isSelected, attributes, className } = props;
	const { source, iconName, iconImage, contentJustification, blockClientId } = attributes;
	return (
		<div className={ classnames( className, {
			[ `is-content-justification-${ contentJustification }` ]: contentJustification,
		}, 'is-vertical', `gutenify-section-${ blockClientId }` ) }>
			{ isSelected && <Inspector { ...props } /> }
			<div className="gutenify-icon-wrapper">
				{ 'icon' === source && <>
					<i className={ iconName }></i>
				</> }
				{ 'image' === source && ( iconImage && iconImage.url !== 'null' && iconImage.url !== '' ) &&

					<IconImage attributes={ attributes } />

				}
			</div>
		</div>
	);
};
export default Edit;
